import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuHeader, MenuLinkContainer, MenuSubtitle,MenuText } from 'Pages/help/components/accountSidebar/menuLink/style';
import { ACCOUNT_SIDEBAR_MENU_LINK_TEST_ID } from 'Pages/help/testId';
import {ICON_IDS} from "Shared/components/icons/constants";
import Icon from 'Shared/components/icons/icon';

type MenuLinkProps = {
  text?    : string,
  header?  : string,
  subtitle?: string,
  url      : string,
  isActive : boolean,
  onClick? : () => void
}
/**
 * Renders the <MenuLink/> component
 */
function MenuLink({text, header, subtitle, url, isActive, onClick}: MenuLinkProps): JSX.Element {
  const navigateTo = useNavigate();

  /**
   * Handles the navigation to the provided URL of the menu item
   */
  const handleNavigation = (): void => {
    navigateTo(url);
    if (onClick) {
      onClick();
    }
  };

  /**
   * Renders the menu link basic text
   * @returns JSX.Element | undefined
   */
  const renderText = (): JSX.Element | undefined => {
    if (!text) {
      return;
    }

    return <MenuText>{ text }</MenuText>;
  };

  /**
   * Renders the menu link header
   * @returns JSX.Element | undefined
   */
  const renderHeader = (): JSX.Element | undefined => {
    if (!header) {
      return;
    }

    return <MenuHeader>{ header }</MenuHeader>;
  };

  /**
   * Renders the menu link subtitle
   * @returns JSX.Element | undefined
   */
  const renderSubtitle = (): JSX.Element | undefined => {
    if (!subtitle) {
      return;
    }

    return <MenuSubtitle>{ subtitle }</MenuSubtitle>;
  };

  return (
    <MenuLinkContainer isActive={ isActive } onClick={ handleNavigation } data-testid={ACCOUNT_SIDEBAR_MENU_LINK_TEST_ID}>
      { renderText() }
      { renderHeader() }
      { renderSubtitle() }
      <Icon iconId={ ICON_IDS.RIGHT_CHEVRON }></Icon>
    </MenuLinkContainer>
  );
}

export default MenuLink;
